export class Assets {
    id?: number;
    readonly objGuid?: string;
    readonly lockVersion?: number;

    costCoverage?: boolean;
    costCoverageAmount?: number;
    researchFundsRequested?: boolean;
    researchFundsApproved?: boolean;
    researchFundsAmount?: number;
    facultyResourcesRequested?: boolean;
    facultyResourcesApproved?: boolean;
    facultyResourcesAmount?: number;
    internationalBudget?: boolean;
    internationalBudgetAmount?: number;
    ownProjectFunds?: boolean;
    ownProjectFundsAmount?: number;
    fee?: boolean;
    feeAmount?: number;
}
